<script>
import * as API from 'api/index'
import ToggleDesc from 'components/toggleDesc/toggleDesc'
export default {
  name: 'NameExplain',
  components: {
    ToggleDesc
  },
  props: {
    liabilityTagList: {
      type: Array,
      default() {
        return []
      }
    },
    interestKeyList: {
      type: Array,
      default() {
        return []
      }
    },
    sortList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      list: [],
      isMoreShow: false
    }
  },
  computed: {
    showList() {
      const { list, isMoreShow } = this
      if (list.length <= 1) return list
      return isMoreShow ? list : list.slice(0, 2)
    }
  },
  watch: {},
  created() {
    const { liabilityTagList, interestKeyList, sortList } = this
    let tagList = []
    liabilityTagList.forEach((item, index) => {
      if (!Array.isArray(item) || item.length <= 0) return
      const newItem = sortList[index]
      if (typeof newItem === 'number' && !isNaN(newItem)) {
        tagList.push(newItem)
      }
    })
    const params = {
      liabilityTagList: tagList,
      interestKeyList
    }
    API.nameExplain(params).then(({ data, success }) => {
      if (!success) return
      this.list = data
      this.$nextTick(() => {
        this.$emit('done')
      })
    })
  },
  methods: {
    toggle(visible) {
      this.isMoreShow = visible
    },
    asyncHandleShow() {
      const visible = !this.isMoreShow
      this.toggle(visible)
      this.syncDelta && this.syncDelta({ pbData: { isNameExplainAllShow: visible } })
    }
  }
}
</script>
<template>
  <div v-if="list.length" :class="`name-explain-wrap name-explain-wrap-v2 ${isMoreShow ? 'name-explain-wrap-v2-more' : ''}`">
    <article class="ne-container">
      <div class="ne-main">
        <div v-for="(item, index) in showList" :key="index" class="ne-item">
          <div class="ne-title">
            {{ item.word ? `${item.word}：` : '' }}{{ item.title }}
          </div>
          <div class="ne-subtitle">
            {{ item.subtitle }}
          </div>
        </div>
      </div>
      <toggle-desc
        v-if="list.length > 1"
        class="toggle-table"
        data-stat-id="mcjs_xq"
        @toggle="asyncHandleShow"
      >
        <template v-if="isMoreShow">
          <span>收起</span>
          <i class="iconfont icon-arrows_up" />
        </template>
        <template v-else>
          <span>展开详情</span>
          <i class="iconfont icon-arrows_down" />
        </template>
      </toggle-desc>
    </article>
  </div>
</template>
<style scoped>
@import 'variable.css';
.name-explain-wrap {
  width: 95.2%;
  margin: 0 auto 10px;
  padding-bottom: 0.7rem;
  background-color: #fff;
  border-radius: 6px;
  .ne-subject {
    position: relative;
    padding: 0.3rem 0;
    font-size: 0.34rem;
    font-weight: 700;
    text-align: center;
  }
  .ne-main {
    padding: 16px 15px 0.88rem;
    background: #f8f8f8;
    border-radius: 6px;
    margin: 0.3rem 0.24rem 0.1rem;
  }
  .ne-item {
    padding-left: 15px;
    margin-bottom: 21px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .ne-title {
    position: relative;
    margin-bottom: 0.18rem;
    font-size: 0.3rem;
    color: #333;
    &:before {
      content: '';
      position: absolute;
      left: -15px;
      top: 0.12rem;
      border: 3px solid #999;
      border-radius: 50%;
      vertical-align: middle;
      border-color: var(--theme-primary-color);
    }
  }
  .ne-subtitle {
    font-size: 0.28rem;
    color: #999;
    line-height: 1.5;
    height: 0.4rem;
    overflow: hidden;
    font-size: 0.26rem;
    text-overflow: ellipsis;
    display: -webkit-box;
    font-weight: normal;
    /* autoprefixer: off */
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
  .toggle-desc {
    font-size: 0.26rem;
    margin-top: -0.92rem;
    color: var(--theme-primary-color);
    > i {
      font-size: 16px;
      vertical-align: middle;
    }
  }
  
}
.name-explain-wrap-v2-more {
  .ne-subtitle {
    height: auto;
    display: block;
    overflow: auto;
  }
}
</style>
